import React from "react";
import { Link } from "react-router-dom";

const AboutFive = () => {
  return (
    <section className='bg-white position-relative z-1 overflow-hidden'>
      <img
        src='assets/images/shapes/shape1.png'
        alt=''
        className='animation-rotation d-sm-block d-none left-15-percent top-0 position-absolute'
      />
      <img
        src='assets/images/shapes/curve-arrow.png'
        alt=''
        className='animate__wobble__two d-sm-block d-none inset-inline-start-63-percent top-25-percent position-absolute z-n1'
      />
      <img
        src='assets/images/shapes/shape3.png'
        alt=''
        className='animation-walking d-sm-block d-none inset-inline-end-7-percent top-0 position-absolute'
      />
      <img
        src='assets/images/shapes/shape5.png'
        alt=''
        className='animation-walking d-sm-block d-none inset-inline-end-32-percent inset-block-end-0 position-absolute z-1'
      />
      <div className='container'>
        <div className='row gy-4 flex-wrap'>
          <div className='col-xl-6'>
            <div className='choose-us__content'>
              <div className='mb-40'>
                <div className='flex-align gap-8 mb-16 wow bounceInDown'>
                  <span className='text-16 text-main-600'>
                    <i className='ph-bold ph-book' />
                  </span>
                  <h5 className='mb-0 text-main-600'>Tentang Kami</h5>
                </div>
                <h2 className='mb-24 wow bounceIn'>
                  Konsultan Riset dan Penulisan Akademik Professional
                </h2>
                <p className='text-neutral-500 wow bounceInUp'>
                  Vibe Research Solution adalah konsultan riset akademik yang berfokus pada pelayanan
                  pengolahan data, analisis riset, dan penulisan karya ilmiah. Didukung oleh tim
                  profesional yang berpengalaman dalam bidang penelitian akademik.
                </p>
              </div>
              <div className='mb-40'>
                <div className='mb-16'>
                  <span className='text-neutral-700 text-20 fw-medium'>
                    Tingkat Kepuasan Klien
                  </span>
                </div>
                <div className='progress-wrapper d-flex align-items-center flex-column gap-4'>
                  <div className='h-50-px position-relative w-100 d-flex'>
                    <span
                      className='floating-label position-absolute text-xl text-main-600 fw-normal radius-8 w-50-px h-32-px z-1 d-flex justify-content-center align-items-center'
                      style={{
                        "--left-percentage": "100%",
                        animationName: "animateFloatingLabel",
                        left: "85%",
                        bottom: "30px",
                      }}
                    >
                      100%
                    </span>

                    <div
                      className='progress mt-auto h-8-px w-100 bg-primary-50 rounded-pill'
                      role='progressbar'
                      aria-label='Basic example'
                      aria-valuenow={100}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className='progress-bar animated-bar rounded-pill bg-primary-gradien overflow-visible'
                        style={{ width: "100%" }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex gap-24 flex-wrap'>
                <div className='max-w-306'>
                  <div className='d-flex gap-12' data-aos='fade-right'>
                    <span>
                      <img
                        src='assets/images/icons/about-us-five-checkbox.png'
                        alt=''
                      />
                    </span>
                    <h5>Visi Kami</h5>
                  </div>
                  <p className='text-14 fw-normal wow bounceIn'>
                    Menjadi konsultan riset akademik terdepan yang menghadirkan solusi
                    inovatif dalam pengembangan karya ilmiah berkualitas tinggi di Indonesia.
                  </p>
                </div>
                <div className='max-w-306'>
                  <div className='d-flex gap-12' data-aos='fade-left'>
                    <span>
                      <img
                        src='assets/images/icons/about-us-five-checkbox.png'
                        alt=''
                      />
                    </span>
                    <h5>Misi Kami</h5>
                  </div>
                  <p className='text-14 fw-normal wow bounceIn'>
                    Memberikan layanan konsultasi riset yang profesional, mendukung kesuksesan akademik
                    mahasiswa melalui pendampingan yang berkualitas dan terpercaya.
                  </p>
                </div>
              </div>
              <div className='d-flex gap-24 flex-wrap mt-40'>
                <div>
                  <Link
                    to='/about'
                    className='btn btn-main rounded-pill flex-align d-inline-flex gap-8'
                    data-aos='fade-right'
                  >
                    Selengkapnya
                    <i className='ph-bold ph-arrow-up-right d-flex text-lg' />
                  </Link>
                </div>
                <div>
                  <div
                    className='d-flex align-content-center gap-16'
                    data-aos='fade-left'
                  >
                    <span className='bg-warning-800 w-54 h-54 rounded-circle justify-content-center text-center align-items-center d-flex text-white'>
                      <img
                        src='assets/images/icons/about-us-five-headset.png'
                        alt=''
                      />
                    </span>
                    <div>
                      <span className='text-16 d-inline-flex mb-4'>
                        Hubungi Kami
                      </span>
                      <h6 className='text-neutral-700'>0831 3148 7736</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutFive;
